import Loading from "../tabs/loading";
import { usePostJson } from "../hooks/usePostJson";

export default function PostUpdateconviction({data, auth}){

 const url="/api/conviction/update";
    const res = usePostJson(url, data, "POST", auth)

    console.log("Del Conv: "+JSON.stringify(data))

    while(res.loading){
        return(<Loading />)
    }

    //alert(JSON.stringify(res))

     if(res.response === null){
      
        return(
            <div style={{color: 'red'}}>
                <>Error in data entry Incomplete for Transaction</>
            </div>
        )
    }

        if(res?.response?.Status === "ERROR"){
        return(
            <div  style={{ color: 'red' }}>
                <bold>Error:</bold> &nbsp; 
                <>{res?.response?.Transaction}</> &nbsp;
                <>{res?.response?.Messages[0]}</>
            </div>
        )
    }

    window.history.back();
    
    return(
        <div style={{color: 'red'}}>
    
        </div>
    )
}